/******/ (() => {
  var __webpack_exports__ = {};
  window.PXUTheme.jsFeaturedPromos = {
    init: function($section) {
      // Scoped selectors
      const $prevButton = $section.find('.featured-promotions__nav--prev');
      const $nextButton = $section.find('.featured-promotions__nav--next');
      const $promoSlider = $section.find('[data-bf-promotions-slider]');

      const $featuredPromosSlider = $promoSlider.flickity({
        initialIndex: 0,
        contain: true,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        imagesLoaded: true,
        draggable: true,
        adaptiveHeight: true
      });

      $featuredPromosSlider.on('settle.flickity', function() {
        $featuredPromosSlider.flickity('resize');
      });

      // Scoped events
      $prevButton.on('click.featuredPromos', function () {
        $featuredPromosSlider.flickity('previous');
      });

      $nextButton.on('click.featuredPromos', function () {
        $featuredPromosSlider.flickity('next');
      });

      // --- FORCE HEIGHT TO UPDATE AFTER CONTENT + IMAGES LOAD ---
      function updateHeight() {
        $featuredPromosSlider.flickity('resize');

        // Optional fallback: directly set height based on tallest cell
        var max = 0;
        $promoSlider.find('.featured-promotions__block').each(function() {
          max = Math.max(max, this.offsetHeight);
        });
        $section.find('.flickity-viewport').css('height', max + 'px');
      }

      // Run after images load
      $featuredPromosSlider.on('imagesLoaded', updateHeight);

      // Run after any slide movement
      $featuredPromosSlider.on('settle.flickity', updateHeight);

      // Run once after initialization
      setTimeout(updateHeight, 300);
      setTimeout(updateHeight, 1000); // catches lazy loads

    },

    blockSelect: function($section, blockId) {
      const $featuredPromosSlider = $section.find('[data-bf-promotions-slider]');
      const slideIndex = $('#shopify-section-' + blockId).data('promo-index');

      $featuredPromosSlider.flickity('select', slideIndex, true, true);
    },

    unload: function($section) {
      const $slider = $section.find('.flickity-enabled');
      $slider.flickity('destroy');

      // Properly scoped .off()
      $section.find('.featured-promotions__nav--prev').off('.featuredPromos');
      $section.find('.featured-promotions__nav--next').off('.featuredPromos');
    }
  };
/******/ })();
